import {AdvancedTable, useAdvancedTable, useFilterContext} from '@eitje/web_components'
import {InvoicesRowDropdown} from './invoices_row_dropdown'
import {TABLE_INFO} from './constants'
import {columns} from './columns'

export const InvoicesAdvancedTable = ({data}) => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler
	const filterContext = useFilterContext()

	const items = data || filterContext?.items

	const tableData = useAdvancedTable({data: items, columns, TABLE_INFO})

	return <AdvancedTable data={tableData} RowDropdownItems={InvoicesRowDropdown} />
}
